import { render, staticRenderFns } from "./CourseDataTableRow.vue?vue&type=template&id=2fb4cc02&"
import script from "./CourseDataTableRow.vue?vue&type=script&lang=js&"
export * from "./CourseDataTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports